import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { useAuth } from "../../../context/AuthContext";
import { AuthShell, AUTH_INPUT, AUTH_LABEL } from "./AuthShell";
import { pwError } from "./pwRules";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { applyAuth } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");
  const invalidToken = token.length < 10;
  const submit = async (e) => {
    e.preventDefault();
    const v = pwError(pw, pw2); if (v) { setErr(v); return; }
    setBusy(true); setErr("");
    try {
      const r = await api.post("/auth/reset-password", { token, password: pw });
      const u = applyAuth(r.data);
      if (u?.platform_role) toast.success("Password diperbarui. Selamat datang kembali.");
      else toast.error("Password diperbarui, tetapi akun ini bukan staf platform.");
      nav("/", { replace: true });
    } catch (e2) { setErr(apiErr(e2, "Gagal mengatur password")); } finally { setBusy(false); }
  };
  return (
    <AuthShell onSubmit={submit} subtitle="Buat password baru" testid="reset-page">
      {invalidToken ? (
        <p className="mt-7 rounded-xl bg-rose-500/10 px-3 py-3 text-xs text-rose-200" data-testid="reset-invalid">Tautan reset tidak valid. <Link to="/forgot-password" className="font-bold underline">Minta tautan baru</Link>.</p>
      ) : (
        <>
          <label className={`${AUTH_LABEL} mt-7`}>Password baru<input className={AUTH_INPUT} type="password" required maxLength={72} autoFocus value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" placeholder="6–72 karakter" data-testid="reset-password" /></label>
          <label className={AUTH_LABEL}>Ulangi password<input className={AUTH_INPUT} type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" data-testid="reset-password-confirm" /></label>
          {err && <p className="mt-3 rounded-xl bg-rose-500/10 px-3 py-2 text-xs text-rose-200" data-testid="reset-error">{err}{/kedaluwarsa|tidak valid/i.test(err) && <> <Link to="/forgot-password" className="font-bold underline">Minta tautan baru</Link></>}</p>}
          <p className="mt-3 text-[11px] text-white/40">Semua sesi lama di perangkat lain akan dikeluarkan.</p>
          <button disabled={busy} className="btn-grad mt-5 w-full rounded-xl py-2.5 text-sm" data-testid="reset-submit">{busy ? <Loader2 size={14} className="mx-auto animate-spin" /> : "Simpan & masuk"}</button>
        </>
      )}
      <Link to="/" className="mt-5 inline-flex items-center gap-1.5 text-xs font-semibold text-white/60 hover:text-white" data-testid="reset-back"><ArrowLeft size={13} /> Kembali ke login</Link>
    </AuthShell>
  );
}
